export function countrys() {
  return [
    {
      name: 'Afghanistan',
      callingCodes: ['93'],
      flag: '/img/flags/af.svg',
      timezones: ['UTC+04:30']
    },
    {
      name: 'Åland Islands',
      callingCodes: ['358'],
      flag: '/img/flags/ax.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Albania',
      callingCodes: ['355'],
      flag: '/img/flags/al.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Algeria',
      callingCodes: ['213'],
      flag: '/img/flags/dz.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'American Samoa',
      callingCodes: ['1684'],
      flag: '/img/flags/as.svg',
      timezones: ['UTC-11:00']
    },
    {
      name: 'Andorra',
      callingCodes: ['376'],
      flag: '/img/flags/ad.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Angola',
      callingCodes: ['244'],
      flag: '/img/flags/ao.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Anguilla',
      callingCodes: ['1264'],
      flag: '/img/flags/ai.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Antarctica',
      callingCodes: ['672'],
      flag: '/img/flags/aq.svg',
      timezones: [
        'UTC-03:00',
        'UTC+03:00',
        'UTC+05:00',
        'UTC+06:00',
        'UTC+07:00',
        'UTC+08:00',
        'UTC+10:00',
        'UTC+12:00'
      ]
    },
    {
      name: 'Antigua and Barbuda',
      callingCodes: ['1268'],
      flag: '/img/flags/ag.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Argentina',
      callingCodes: ['54'],
      flag: '/img/flags/ar.svg',
      timezones: ['UTC-03:00']
    },
    {
      name: 'Armenia',
      callingCodes: ['374'],
      flag: '/img/flags/am.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Aruba',
      callingCodes: ['297'],
      flag: '/img/flags/aw.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Australia',
      callingCodes: ['61'],
      flag: '/img/flags/au.svg',
      timezones: [
        'UTC+05:00',
        'UTC+06:30',
        'UTC+07:00',
        'UTC+08:00',
        'UTC+09:30',
        'UTC+10:00',
        'UTC+10:30',
        'UTC+11:30'
      ]
    },
    {
      name: 'Austria',
      callingCodes: ['43'],
      flag: '/img/flags/at.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Azerbaijan',
      callingCodes: ['994'],
      flag: '/img/flags/az.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Bahamas',
      callingCodes: ['1242'],
      flag: '/img/flags/bs.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Bahrain',
      callingCodes: ['973'],
      flag: '/img/flags/bh.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Bangladesh',
      callingCodes: ['880'],
      flag: '/img/flags/bd.svg',
      timezones: ['UTC+06:00']
    },
    {
      name: 'Barbados',
      callingCodes: ['1246'],
      flag: '/img/flags/bb.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Belarus',
      callingCodes: ['375'],
      flag: '/img/flags/by.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Belgium',
      callingCodes: ['32'],
      flag: '/img/flags/be.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Belize',
      callingCodes: ['501'],
      flag: '/img/flags/bz.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Benin',
      callingCodes: ['229'],
      flag: '/img/flags/bj.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Bermuda',
      callingCodes: ['1441'],
      flag: '/img/flags/bm.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Bhutan',
      callingCodes: ['975'],
      flag: '/img/flags/bt.svg',
      timezones: ['UTC+06:00']
    },
    {
      name: 'Bolivia (Plurinational State of)',
      callingCodes: ['591'],
      flag: '/img/flags/bo.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Bonaire, Sint Eustatius and Saba',
      callingCodes: ['5997'],
      flag: '/img/flags/be.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Bosnia and Herzegovina',
      callingCodes: ['387'],
      flag: '/img/flags/ba.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Botswana',
      callingCodes: ['267'],
      flag: '/img/flags/bw.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Bouvet Island',
      callingCodes: [''],
      flag: '/img/flags/bv.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Brazil',
      callingCodes: ['55'],
      flag: '/img/flags/br.svg',
      timezones: ['UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00']
    },
    {
      name: 'British Indian Ocean Territory',
      callingCodes: ['246'],
      flag: '/img/flags/io.svg',
      timezones: ['UTC+06:00']
    },
    {
      name: 'United States Minor Outlying Islands',
      callingCodes: [''],
      flag: '/img/flags/um.svg',
      timezones: ['UTC-11:00', 'UTC-10:00', 'UTC+12:00']
    },
    {
      name: 'Virgin Islands (British)',
      callingCodes: ['1284'],
      flag: '/img/flags/vg.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Virgin Islands (U.S.)',
      callingCodes: ['1 340'],
      flag: '/img/flags/vi.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Brunei Darussalam',
      callingCodes: ['673'],
      flag: '/img/flags/bn.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Bulgaria',
      callingCodes: ['359'],
      flag: '/img/flags/bg.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Burkina Faso',
      callingCodes: ['226'],
      flag: '/img/flags/bf.svg',
      timezones: ['UTC']
    },
    {
      name: 'Burundi',
      callingCodes: ['257'],
      flag: '/img/flags/bi.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Cambodia',
      callingCodes: ['855'],
      flag: '/img/flags/kh.svg',
      timezones: ['UTC+07:00']
    },
    {
      name: 'Cameroon',
      callingCodes: ['237'],
      flag: '/img/flags/cm.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Canada',
      callingCodes: ['1'],
      flag: '/img/flags/ca.svg',
      timezones: ['UTC-08:00', 'UTC-07:00', 'UTC-06:00', 'UTC-05:00', 'UTC-04:00', 'UTC-03:30']
    },
    {
      name: 'Cabo Verde',
      callingCodes: ['238'],
      flag: '/img/flags/cv.svg',
      timezones: ['UTC-01:00']
    },
    {
      name: 'Cayman Islands',
      callingCodes: ['1345'],
      flag: '/img/flags/ky.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Central African Republic',
      callingCodes: ['236'],
      flag: '/img/flags/cf.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Chad',
      callingCodes: ['235'],
      flag: '/img/flags/tc.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Chile',
      callingCodes: ['56'],
      flag: '/img/flags/td.svg',
      timezones: ['UTC-06:00', 'UTC-04:00']
    },
    {
      name: 'China',
      callingCodes: ['86'],
      flag: '/img/flags/cn.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Christmas Island',
      callingCodes: ['61'],
      flag: '/img/flags/cx.svg',
      timezones: ['UTC+07:00']
    },
    {
      name: 'Cocos (Keeling) Islands',
      callingCodes: ['61'],
      flag: '/img/flags/cc.svg',
      timezones: ['UTC+06:30']
    },
    {
      name: 'Colombia',
      callingCodes: ['57'],
      flag: '/img/flags/co.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Comoros',
      callingCodes: ['269'],
      flag: '/img/flags/km.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Congo',
      callingCodes: ['242'],
      flag: '/img/flags/cg.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Congo (Democratic Republic of the)',
      callingCodes: ['243'],
      flag: '/img/flags/cd.svg',
      timezones: ['UTC+01:00', 'UTC+02:00']
    },
    {
      name: 'Cook Islands',
      callingCodes: ['682'],
      flag: '/img/flags/ck.svg',
      timezones: ['UTC-10:00']
    },
    {
      name: 'Costa Rica',
      callingCodes: ['506'],
      flag: '/img/flags/cr.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Croatia',
      callingCodes: ['385'],
      flag: '/img/flags/hr.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Cuba',
      callingCodes: ['53'],
      flag: '/img/flags/cu.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Curaçao',
      callingCodes: ['599'],
      flag: '/img/flags/cu.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Cyprus',
      callingCodes: ['357'],
      flag: '/img/flags/cy.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Czech Republic',
      callingCodes: ['420'],
      flag: '/img/flags/cz.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Denmark',
      callingCodes: ['45'],
      flag: '/img/flags/dk.svg',
      timezones: ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC', 'UTC+01:00']
    },
    {
      name: 'Djibouti',
      callingCodes: ['253'],
      flag: '/img/flags/dj.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Dominica',
      callingCodes: ['1767'],
      flag: '/img/flags/dm.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Dominican Republic',
      callingCodes: ['1809', '1829', '1849'],
      flag: '/img/flags/do.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Ecuador',
      callingCodes: ['593'],
      flag: '/img/flags/ec.svg',
      timezones: ['UTC-06:00', 'UTC-05:00']
    },
    {
      name: 'Egypt',
      callingCodes: ['20'],
      flag: '/img/flags/eg.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'El Salvador',
      callingCodes: ['503'],
      flag: '/img/flags/sv.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Equatorial Guinea',
      callingCodes: ['240'],
      flag: '/img/flags/gq.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Eritrea',
      callingCodes: ['291'],
      flag: '/img/flags/er.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Estonia',
      callingCodes: ['372'],
      flag: '/img/flags/ee.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Ethiopia',
      callingCodes: ['251'],
      flag: '/img/flags/et.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Falkland Islands (Malvinas)',
      callingCodes: ['500'],
      flag: '/img/flags/fk.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Faroe Islands',
      callingCodes: ['298'],
      flag: '/img/flags/fo.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Fiji',
      callingCodes: ['679'],
      flag: '/img/flags/fj.svg',
      timezones: ['UTC+12:00']
    },
    {
      name: 'Finland',
      callingCodes: ['358'],
      flag: '/img/flags/fi.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'France',
      callingCodes: ['33'],
      flag: '/img/flags/fr.svg',
      timezones: [
        'UTC-10:00',
        'UTC-09:30',
        'UTC-09:00',
        'UTC-08:00',
        'UTC-04:00',
        'UTC-03:00',
        'UTC+01:00',
        'UTC+03:00',
        'UTC+04:00',
        'UTC+05:00',
        'UTC+11:00',
        'UTC+12:00'
      ]
    },
    {
      name: 'French Guiana',
      callingCodes: ['594'],
      flag: '/img/flags/gf.svg',
      timezones: ['UTC-03:00']
    },
    {
      name: 'French Polynesia',
      callingCodes: ['689'],
      flag: '/img/flags/tf.svg',
      timezones: ['UTC-10:00', 'UTC-09:30', 'UTC-09:00']
    },
    {
      name: 'French Southern Territories',
      callingCodes: [''],
      flag: '/img/flags/tf.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Gabon',
      callingCodes: ['241'],
      flag: '/img/flags/ga.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Gambia',
      callingCodes: ['220'],
      flag: '/img/flags/gm.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Georgia',
      callingCodes: ['995'],
      flag: '/img/flags/ge.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Germany',
      callingCodes: ['49'],
      flag: '/img/flags/de.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Ghana',
      callingCodes: ['233'],
      flag: '/img/flags/gh.svg',
      timezones: ['UTC']
    },
    {
      name: 'Gibraltar',
      callingCodes: ['350'],
      flag: '/img/flags/gi.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Greece',
      callingCodes: ['30'],
      flag: '/img/flags/gr.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Greenland',
      callingCodes: ['299'],
      flag: '/img/flags/gl.svg',
      timezones: ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC+00:00']
    },
    {
      name: 'Grenada',
      callingCodes: ['1473'],
      flag: '/img/flags/gd.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Guadeloupe',
      callingCodes: ['590'],
      flag: '/img/flags/gp.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Guam',
      callingCodes: ['1671'],
      flag: '/img/flags/gu.svg',
      timezones: ['UTC+10:00']
    },
    {
      name: 'Guatemala',
      callingCodes: ['502'],
      flag: '/img/flags/gg.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Guernsey',
      callingCodes: ['44'],
      flag: '/img/flags/gg.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Guinea',
      callingCodes: ['224'],
      flag: '/img/flags/gq.svg',
      timezones: ['UTC']
    },
    {
      name: 'Guinea-Bissau',
      callingCodes: ['245'],
      flag: '/img/flags/gw.svg',
      timezones: ['UTC']
    },
    {
      name: 'Guyana',
      callingCodes: ['592'],
      flag: '/img/flags/gy.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Haiti',
      callingCodes: ['509'],
      flag: '/img/flags/ht.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Heard Island and McDonald Islands',
      callingCodes: [''],
      flag: '/img/flags/hm.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Holy See',
      callingCodes: ['379'],
      flag: '/img/flags/va.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Honduras',
      callingCodes: ['504'],
      flag: '/img/flags/hn.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Hong Kong',
      callingCodes: ['852'],
      flag: '/img/flags/hk.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Hungary',
      callingCodes: ['36'],
      flag: '/img/flags/hu.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Iceland',
      callingCodes: ['354'],
      flag: '/img/flags/is.svg',
      timezones: ['UTC']
    },
    {
      name: 'India',
      callingCodes: ['91'],
      flag: '/img/flags/in.svg',
      timezones: ['UTC+05:30']
    },
    {
      name: 'Indonesia',
      callingCodes: ['62'],
      flag: '/img/flags/id.svg',
      timezones: ['UTC+07:00', 'UTC+08:00', 'UTC+09:00']
    },
    {
      name: "Côte d'Ivoire",
      callingCodes: ['225'],
      flag: '/img/flags/ci.svg',
      timezones: ['UTC']
    },
    {
      name: 'Iran (Islamic Republic of)',
      callingCodes: ['98'],
      flag: '/img/flags/ir.svg',
      timezones: ['UTC+03:30']
    },
    {
      name: 'Iraq',
      callingCodes: ['964'],
      flag: '/img/flags/iq.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Ireland',
      callingCodes: ['353'],
      flag: '/img/flags/ie.svg',
      timezones: ['UTC']
    },
    {
      name: 'Isle of Man',
      callingCodes: ['44'],
      flag: '/img/flags/im.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Israel',
      callingCodes: ['972'],
      flag: '/img/flags/il.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Italy',
      callingCodes: ['39'],
      flag: '/img/flags/it.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Jamaica',
      callingCodes: ['1876'],
      flag: '/img/flags/jm.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Japan',
      callingCodes: ['81'],
      flag: '/img/flags/jp.svg',
      timezones: ['UTC+09:00']
    },
    {
      name: 'Jersey',
      callingCodes: ['44'],
      flag: '/img/flags/je.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Jordan',
      callingCodes: ['962'],
      flag: '/img/flags/jo.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Kazakhstan',
      callingCodes: ['76', '77'],
      flag: '/img/flags/kz.svg',
      timezones: ['UTC+05:00', 'UTC+06:00']
    },
    {
      name: 'Kenya',
      callingCodes: ['254'],
      flag: '/img/flags/ke.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Kiribati',
      callingCodes: ['686'],
      flag: '/img/flags/ki.svg',
      timezones: ['UTC+12:00', 'UTC+13:00', 'UTC+14:00']
    },
    {
      name: 'Kuwait',
      callingCodes: ['965'],
      flag: '/img/flags/kw.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Kyrgyzstan',
      callingCodes: ['996'],
      flag: '/img/flags/kg.svg',
      timezones: ['UTC+06:00']
    },
    {
      name: "Lao People's Democratic Republic",
      callingCodes: ['856'],
      flag: '/img/flags/la.svg',
      timezones: ['UTC+07:00']
    },
    {
      name: 'Latvia',
      callingCodes: ['371'],
      flag: '/img/flags/lv.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Lebanon',
      callingCodes: ['961'],
      flag: '/img/flags/lb.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Lesotho',
      callingCodes: ['266'],
      flag: '/img/flags/ls.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Liberia',
      callingCodes: ['231'],
      flag: '/img/flags/lr.svg',
      timezones: ['UTC']
    },
    {
      name: 'Libya',
      callingCodes: ['218'],
      flag: '/img/flags/ly.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Liechtenstein',
      callingCodes: ['423'],
      flag: '/img/flags/li.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Lithuania',
      callingCodes: ['370'],
      flag: '/img/flags/lt.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Luxembourg',
      callingCodes: ['352'],
      flag: '/img/flags/lu.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Macao',
      callingCodes: ['853'],
      flag: '/img/flags/mo.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Macedonia (the former Yugoslav Republic of)',
      callingCodes: ['389'],
      flag: '/img/flags/mk.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Madagascar',
      callingCodes: ['261'],
      flag: '/img/flags/mg.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Malawi',
      callingCodes: ['265'],
      flag: '/img/flags/mw.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Malaysia',
      callingCodes: ['60'],
      flag: '/img/flags/my.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Maldives',
      callingCodes: ['960'],
      flag: '/img/flags/mv.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Mali',
      callingCodes: ['223'],
      flag: '/img/flags/ml.svg',
      timezones: ['UTC']
    },
    {
      name: 'Malta',
      callingCodes: ['356'],
      flag: '/img/flags/mt.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Marshall Islands',
      callingCodes: ['692'],
      flag: '/img/flags/mh.svg',
      timezones: ['UTC+12:00']
    },
    {
      name: 'Martinique',
      callingCodes: ['596'],
      flag: '/img/flags/mq.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Mauritania',
      callingCodes: ['222'],
      flag: '/img/flags/mr.svg',
      timezones: ['UTC']
    },
    {
      name: 'Mauritius',
      callingCodes: ['230'],
      flag: '/img/flags/mu.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Mayotte',
      callingCodes: ['262'],
      flag: '/img/flags/yt.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Mexico',
      callingCodes: ['52'],
      flag: '/img/flags/mx.svg',
      timezones: ['UTC-08:00', 'UTC-07:00', 'UTC-06:00']
    },
    {
      name: 'Micronesia (Federated States of)',
      callingCodes: ['691'],
      flag: '/img/flags/fm.svg',
      timezones: ['UTC+10:00', 'UTC+11']
    },
    {
      name: 'Moldova (Republic of)',
      callingCodes: ['373'],
      flag: '/img/flags/md.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Monaco',
      callingCodes: ['377'],
      flag: '/img/flags/mc.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Mongolia',
      callingCodes: ['976'],
      flag: '/img/flags/mn.svg',
      timezones: ['UTC+07:00', 'UTC+08:00']
    },
    {
      name: 'Montenegro',
      callingCodes: ['382'],
      flag: '/img/flags/me.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Montserrat',
      callingCodes: ['1664'],
      flag: '/img/flags/ms.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Morocco',
      callingCodes: ['212'],
      flag: '/img/flags/ma.svg',
      timezones: ['UTC']
    },
    {
      name: 'Mozambique',
      callingCodes: ['258'],
      flag: '/img/flags/mz.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Myanmar',
      callingCodes: ['95'],
      flag: '/img/flags/mm.svg',
      timezones: ['UTC+06:30']
    },
    {
      name: 'Namibia',
      callingCodes: ['264'],
      flag: '/img/flags/na.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Nauru',
      callingCodes: ['674'],
      flag: '/img/flags/nr.svg',
      timezones: ['UTC+12:00']
    },
    {
      name: 'Nepal',
      callingCodes: ['977'],
      flag: '/img/flags/np.svg',
      timezones: ['UTC+05:45']
    },
    {
      name: 'Netherlands',
      callingCodes: ['31'],
      flag: '/img/flags/nl.svg',
      timezones: ['UTC-04:00', 'UTC+01:00']
    },
    {
      name: 'New Caledonia',
      callingCodes: ['687'],
      flag: '/img/flags/nc.svg',
      timezones: ['UTC+11:00']
    },
    {
      name: 'New Zealand',
      callingCodes: ['64'],
      flag: '/img/flags/nz.svg',
      timezones: ['UTC-11:00', 'UTC-10:00', 'UTC+12:00', 'UTC+12:45', 'UTC+13:00']
    },
    {
      name: 'Nicaragua',
      callingCodes: ['505'],
      flag: '/img/flags/ni.svg',
      timezones: ['UTC-06:00']
    },
    {
      name: 'Niger',
      callingCodes: ['227'],
      flag: '/img/flags/ng.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Nigeria',
      callingCodes: ['234'],
      flag: '/img/flags/ng.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Niue',
      callingCodes: ['683'],
      flag: '/img/flags/ni.svg',
      timezones: ['UTC-11:00']
    },
    {
      name: 'Norfolk Island',
      callingCodes: ['672'],
      flag: '/img/flags/nf.svg',
      timezones: ['UTC+11:30']
    },
    {
      name: "Korea (Democratic People's Republic of)",
      callingCodes: ['850'],
      flag: '/img/flags/kp.svg',
      timezones: ['UTC+09:00']
    },
    {
      name: 'Northern Mariana Islands',
      callingCodes: ['1670'],
      flag: '/img/flags/mp.svg',
      timezones: ['UTC+10:00']
    },
    {
      name: 'Norway',
      callingCodes: ['47'],
      flag: '/img/flags/no.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Oman',
      callingCodes: ['968'],
      flag: '/img/flags/om.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Pakistan',
      callingCodes: ['92'],
      flag: '/img/flags/pk.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Palau',
      callingCodes: ['680'],
      flag: '/img/flags/pl.svg',
      timezones: ['UTC+09:00']
    },
    {
      name: 'Palestine, State of',
      callingCodes: ['970'],
      flag: '/img/flags/ps.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Panama',
      callingCodes: ['507'],
      flag: '/img/flags/pa.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Papua New Guinea',
      callingCodes: ['675'],
      flag: '/img/flags/pg.svg',
      timezones: ['UTC+10:00']
    },
    {
      name: 'Paraguay',
      callingCodes: ['595'],
      flag: '/img/flags/py.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Peru',
      callingCodes: ['51'],
      flag: '/img/flags/pe.svg',
      timezones: ['UTC-05:00']
    },
    {
      name: 'Philippines',
      callingCodes: ['63'],
      flag: '/img/flags/ph.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Pitcairn',
      callingCodes: ['64'],
      flag: '/img/flags/pn.svg',
      timezones: ['UTC-08:00']
    },
    {
      name: 'Poland',
      callingCodes: ['48'],
      flag: '/img/flags/pl.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Portugal',
      callingCodes: ['351'],
      flag: '/img/flags/pt.svg',
      timezones: ['UTC-01:00', 'UTC']
    },
    {
      name: 'Puerto Rico',
      callingCodes: ['1787', '1939'],
      flag: '/img/flags/pr.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Qatar',
      callingCodes: ['974'],
      flag: '/img/flags/qa.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Republic of Kosovo',
      callingCodes: ['383'],
      flag: '/img/flags/xk.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Réunion',
      callingCodes: ['262'],
      flag: '/img/flags/re.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Romania',
      callingCodes: ['40'],
      flag: '/img/flags/ro.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Russian Federation',
      callingCodes: ['7'],
      flag: '/img/flags/ru.svg',
      timezones: [
        'UTC+03:00',
        'UTC+04:00',
        'UTC+06:00',
        'UTC+07:00',
        'UTC+08:00',
        'UTC+09:00',
        'UTC+10:00',
        'UTC+11:00',
        'UTC+12:00'
      ]
    },
    {
      name: 'Rwanda',
      callingCodes: ['250'],
      flag: '/img/flags/rw.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Saint Barthélemy',
      callingCodes: ['590'],
      flag: '/img/flags/bl.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Saint Helena, Ascension and Tristan da Cunha',
      callingCodes: ['290'],
      flag: '/img/flags/sh.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Saint Kitts and Nevis',
      callingCodes: ['1869'],
      flag: '/img/flags/kn.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Saint Lucia',
      callingCodes: ['1758'],
      flag: '/img/flags/lc.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Saint Martin (French part)',
      callingCodes: ['590'],
      flag: '/img/flags/mf.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Saint Pierre and Miquelon',
      callingCodes: ['508'],
      flag: '/img/flags/pm.svg',
      timezones: ['UTC-03:00']
    },
    {
      name: 'Saint Vincent and the Grenadines',
      callingCodes: ['1784'],
      flag: '/img/flags/vc.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Samoa',
      callingCodes: ['685'],
      flag: '/img/flags/ws.svg',
      timezones: ['UTC+13:00']
    },
    {
      name: 'San Marino',
      callingCodes: ['378'],
      flag: '/img/flags/sm.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Sao Tome and Principe',
      callingCodes: ['239'],
      flag: '/img/flags/st.svg',
      timezones: ['UTC']
    },
    {
      name: 'Saudi Arabia',
      callingCodes: ['966'],
      flag: '/img/flags/sa.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Senegal',
      callingCodes: ['221'],
      flag: '/img/flags/sn.svg',
      timezones: ['UTC']
    },
    {
      name: 'Serbia',
      callingCodes: ['381'],
      flag: '/img/flags/rs.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Seychelles',
      callingCodes: ['248'],
      flag: '/img/flags/sc.svg',
      timezones: ['UTC+04:00']
    },
    {
      name: 'Sierra Leone',
      callingCodes: ['232'],
      flag: '/img/flags/sl.svg',
      timezones: ['UTC']
    },
    {
      name: 'Singapore',
      callingCodes: ['65'],
      flag: '/img/flags/sg.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Sint Maarten (Dutch part)',
      callingCodes: ['1721'],
      flag: '/img/flags/sx.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Slovakia',
      callingCodes: ['421'],
      flag: '/img/flags/sk.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Slovenia',
      callingCodes: ['386'],
      flag: '/img/flags/si.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Solomon Islands',
      callingCodes: ['677'],
      flag: '/img/flags/sb.svg',
      timezones: ['UTC+11:00']
    },
    {
      name: 'Somalia',
      callingCodes: ['252'],
      flag: '/img/flags/so.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'South Africa',
      callingCodes: ['27'],
      flag: '/img/flags/za.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'South Georgia and the South Sandwich Islands',
      callingCodes: ['500'],
      flag: '/img/flags/gs.svg',
      timezones: ['UTC-02:00']
    },
    {
      name: 'Korea (Republic of)',
      callingCodes: ['82'],
      flag: '/img/flags/kp.svg',
      timezones: ['UTC+09:00']
    },
    {
      name: 'South Sudan',
      callingCodes: ['211'],
      flag: '/img/flags/ss.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Spain',
      callingCodes: ['34'],
      flag: '/img/flags/es.svg',
      timezones: ['UTC', 'UTC+01:00']
    },
    {
      name: 'Sri Lanka',
      callingCodes: ['94'],
      flag: '/img/flags/lk.svg',
      timezones: ['UTC+05:30']
    },
    {
      name: 'Sudan',
      callingCodes: ['249'],
      flag: '/img/flags/sd.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Suriname',
      callingCodes: ['597'],
      flag: '/img/flags/sr.svg',
      timezones: ['UTC-03:00']
    },
    {
      name: 'Svalbard and Jan Mayen',
      callingCodes: ['4779'],
      flag: '/img/flags/sj.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Swaziland',
      callingCodes: ['268'],
      flag: '/img/flags/sz.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Sweden',
      callingCodes: ['46'],
      flag: '/img/flags/se.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Switzerland',
      callingCodes: ['41'],
      flag: '/img/flags/ch.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Syrian Arab Republic',
      callingCodes: ['963'],
      flag: '/img/flags/sy.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Taiwan',
      callingCodes: ['886'],
      flag: '/img/flags/tw.svg',
      timezones: ['UTC+08:00']
    },
    {
      name: 'Tajikistan',
      callingCodes: ['992'],
      flag: '/img/flags/tj.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Tanzania, United Republic of',
      callingCodes: ['255'],
      flag: '/img/flags/tz.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Thailand',
      callingCodes: ['66'],
      flag: '/img/flags/th.svg',
      timezones: ['UTC+07:00']
    },
    {
      name: 'Timor-Leste',
      callingCodes: ['670'],
      flag: '/img/flags/tl.svg',
      timezones: ['UTC+09:00']
    },
    {
      name: 'Togo',
      callingCodes: ['228'],
      flag: '/img/flags/tg.svg',
      timezones: ['UTC']
    },
    {
      name: 'Tokelau',
      callingCodes: ['690'],
      flag: '/img/flags/tk.svg',
      timezones: ['UTC+13:00']
    },
    {
      name: 'Tonga',
      callingCodes: ['676'],
      flag: '/img/flags/to.svg',
      timezones: ['UTC+13:00']
    },
    {
      name: 'Trinidad and Tobago',
      callingCodes: ['1868'],
      flag: '/img/flags/tt.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Tunisia',
      callingCodes: ['216'],
      flag: '/img/flags/tn.svg',
      timezones: ['UTC+01:00']
    },
    {
      name: 'Turkey',
      callingCodes: ['90'],
      flag: '/img/flags/tr.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Turkmenistan',
      callingCodes: ['993'],
      flag: '/img/flags/tm.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Turks and Caicos Islands',
      callingCodes: ['1649'],
      flag: '/img/flags/tc.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Tuvalu',
      callingCodes: ['688'],
      flag: '/img/flags/tv.svg',
      timezones: ['UTC+12:00']
    },
    {
      name: 'Uganda',
      callingCodes: ['256'],
      flag: '/img/flags/ug.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Ukraine',
      callingCodes: ['380'],
      flag: '/img/flags/ua.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'United Arab Emirates',
      callingCodes: ['971'],
      flag: '/img/flags/ae.svg',
      timezones: ['UTC+04']
    },
    {
      name: 'United Kingdom of Great Britain and Northern Ireland',
      callingCodes: ['44'],
      flag: '/img/flags/gb.svg',
      timezones: [
        'UTC-08:00',
        'UTC-05:00',
        'UTC-04:00',
        'UTC-03:00',
        'UTC-02:00',
        'UTC',
        'UTC+01:00',
        'UTC+02:00',
        'UTC+06:00'
      ]
    },
    {
      name: 'United States of America',
      callingCodes: ['1'],
      flag: '/img/flags/us.svg',
      timezones: [
        'UTC-12:00',
        'UTC-11:00',
        'UTC-10:00',
        'UTC-09:00',
        'UTC-08:00',
        'UTC-07:00',
        'UTC-06:00',
        'UTC-05:00',
        'UTC-04:00',
        'UTC+10:00',
        'UTC+12:00'
      ]
    },
    {
      name: 'Uruguay',
      callingCodes: ['598'],
      flag: '/img/flags/uy.svg',
      timezones: ['UTC-03:00']
    },
    {
      name: 'Uzbekistan',
      callingCodes: ['998'],
      flag: '/img/flags/uz.svg',
      timezones: ['UTC+05:00']
    },
    {
      name: 'Vanuatu',
      callingCodes: ['678'],
      flag: '/img/flags/vu.svg',
      timezones: ['UTC+11:00']
    },
    {
      name: 'Venezuela (Bolivarian Republic of)',
      callingCodes: ['58'],
      flag: '/img/flags/ve.svg',
      timezones: ['UTC-04:00']
    },
    {
      name: 'Viet Nam',
      callingCodes: ['84'],
      flag: '/img/flags/vn.svg',
      timezones: ['UTC+07:00']
    },
    {
      name: 'Wallis and Futuna',
      callingCodes: ['681'],
      flag: '/img/flags/wf.svg',
      timezones: ['UTC+12:00']
    },
    {
      name: 'Western Sahara',
      callingCodes: ['212'],
      flag: '/img/flags/eh.svg',
      timezones: ['UTC+00:00']
    },
    {
      name: 'Yemen',
      callingCodes: ['967'],
      flag: '/img/flags/ye.svg',
      timezones: ['UTC+03:00']
    },
    {
      name: 'Zambia',
      callingCodes: ['260'],
      flag: '/img/flags/zm.svg',
      timezones: ['UTC+02:00']
    },
    {
      name: 'Zimbabwe',
      callingCodes: ['263'],
      flag: '/img/flags/zw.svg',
      timezones: ['UTC+02:00']
    }
  ]
}

export function themesEmails() {
  return [
    {
      name: 'Alura',
      thumbnailUri: require('@/assets/imgs/template003.png'),
      htmlContent: `<!doctype html>
      <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

      <head>
        <title>
        </title>
        <!--[if !mso]><!-- -->
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <!--<![endif]-->
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style type="text/css">
          #outlook a {
            padding: 0;
          }

          body {
            margin: 0;
            padding: 0;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
          }

          table,
          td {
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
          }

          img {
            border: 0;
            height: auto;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            -ms-interpolation-mode: bicubic;
          }

          p {
            display: block;
            margin: 13px 0;
          }
        </style>
        <!--[if mso]>
              <xml>
              <o:OfficeDocumentSettings>
                <o:AllowPNG/>
                <o:PixelsPerInch>96</o:PixelsPerInch>
              </o:OfficeDocumentSettings>
              </xml>
              <![endif]-->
        <!--[if lte mso 11]>
              <style type="text/css">
                .mj-outlook-group-fix { width:100% !important; }
              </style>
              <![endif]-->
        <style type="text/css">
          @media only screen and (min-width:480px) {
            .mj-column-per-100 {
              width: 100% !important;
              max-width: 100%;
            }
          }
        </style>
        <style type="text/css">
          @media only screen and (max-width:480px) {
            table.mj-full-width-mobile {
              width: 100% !important;
            }

            td.mj-full-width-mobile {
              width: auto !important;
            }
          }
        </style>
      </head>

      <body style="background-color:#F4F4F4;">
        <div style="background-color:#F4F4F4;">
          <!--[if mso | IE]>
            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-bottom:30px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:180px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g86w/0g67t.png" style="border:none;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" title="" width="180" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="line-height: 18px; margin: 10px 0; text-align: center;font-size:14px;color:#ffffff;font-family:'Times New Roman',Helvetica,Arial,sans-serif">WOMEN&nbsp; &nbsp; &nbsp; &nbsp;| &nbsp; &nbsp; &nbsp; MEN&nbsp; &nbsp; &nbsp; &nbsp;| &nbsp; &nbsp; &nbsp; KIDS</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:0 0 0 0;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:0px 25px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:600px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g86w/0696u.jpeg" style="border:none;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" title="" width="600" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:0 0 0 0;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:25px;padding-bottom:5px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="line-height: 60px; text-align: center; margin: 10px 0;font-size:55px;color:#fcfcfc;font-family:'Times New Roman',Helvetica,Arial,sans-serif"><b>Black Friday</b></p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:20px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="line-height: 30px; text-align: center; margin: 10px 0;color:#f5f5f5;font-size:25px;font-family:'Times New Roman',Helvetica,Arial,sans-serif"><b>Take an&nbsp; extra 50% off</b><br /><span style="color:#ffffff;font-size:18px;font-family:'Times New Roman',Helvetica,Arial,sans-serif">Use code SALEONSALE* at checkout</span></p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:0 0 0 0;padding-bottom:40px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;padding-bottom:30px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                              <tr>
                                <td align="center" bgcolor="#ffffff" role="presentation" style="border:none;border-radius:3px;cursor:auto;mso-padding-alt:10px 25px;background:#ffffff;" valign="middle">
                                  <p style="display:inline-block;background:#ffffff;color:#ffffff;font-family:Times New Roman, Helvetica, Arial, sans-serif;font-size:18px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:3px;">
                                    <span style="color:#212020">Shop Now</span>
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="line-height: 16px; text-align: center; margin: 10px 0;font-size:12px;color:#ffffff;font-family:'Times New Roman',Helvetica,Arial,sans-serif">* Offer valid on Allura purchases on 17/29/11 at 11:59 pm. No price adjustments on previous&nbsp;<br /><span style="color:#ffffff;font-family:'Times New Roman',Helvetica,Arial,sans-serif">purchases, offer limited to stock. Cannot be combined with any offer or promotion other than free.</span></p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>
            <![endif]-->
        </div>
      </body>

      </html>`
    },
    {
      name: 'Christmas',
      thumbnailUri: require('@/assets/imgs/template004.png'),
      htmlContent: `<!doctype html>
      <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

      <head>
        <title>
        </title>
        <!--[if !mso]><!-- -->
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <!--<![endif]-->
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style type="text/css">
          #outlook a {
            padding: 0;
          }

          body {
            margin: 0;
            padding: 0;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
          }

          table,
          td {
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
          }

          img {
            border: 0;
            height: auto;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            -ms-interpolation-mode: bicubic;
          }

          p {
            display: block;
            margin: 13px 0;
          }
        </style>
        <!--[if mso]>
              <xml>
              <o:OfficeDocumentSettings>
                <o:AllowPNG/>
                <o:PixelsPerInch>96</o:PixelsPerInch>
              </o:OfficeDocumentSettings>
              </xml>
              <![endif]-->
        <!--[if lte mso 11]>
              <style type="text/css">
                .mj-outlook-group-fix { width:100% !important; }
              </style>
              <![endif]-->
        <style type="text/css">
          @media only screen and (min-width:480px) {
            .mj-column-per-100 {
              width: 100% !important;
              max-width: 100%;
            }

            .mj-column-per-50 {
              width: 50% !important;
              max-width: 50%;
            }
          }
        </style>
        <style type="text/css">
          @media only screen and (max-width:480px) {
            table.mj-full-width-mobile {
              width: 100% !important;
            }

            td.mj-full-width-mobile {
              width: auto !important;
            }
          }
        </style>
      </head>

      <body style="background-color:#F4F4F4;">
        <div style="background-color:#F4F4F4;">
          <!--[if mso | IE]>
            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:30px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:214px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/0gztq.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="214" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:15px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="text-align: center; margin: 10px 0;color:#151e23;font-size:14px;font-family:Georgia,Helvetica,Arial,sans-serif">Product | Concept | Contact</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:600px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/068ys.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:30px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;padding-bottom:10px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:30px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="line-height: 30px; margin: 10px 0; text-align: center; color:#151e23; font-size:30p; font-family:Georgia,Helvetica,Arial,sans-serif">- Our Holiday Recipes -</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:30px;padding-bottom:20px;padding-left:30px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:240px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/0gzvp.jpeg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="240" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:40px;padding-bottom:0px;padding-left:40px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="margin: 10px 0; color:#151e23; font-size:16px; font-family:Georgia,Helvetica,Arial,sans-serif"><b>Cake Title</b></p>
                              <p style="line-height: 16px; margin: 10px 0;font-size:14px; color:#151e23; font-family:Georgia,Helvetica,Arial,sans-serif; color:#354552">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                              <p style="line-height: 16px; margin: 10px 0; color:#354552; font-size:14px; font-family:Georgia,Helvetica,Arial,sans-serif"><u>Choose me</u> &gt;</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:rtl;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-top:20px;padding-right:30px;padding-bottom:20px;padding-left:30px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:240px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/0gzv6.jpeg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="240" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:40px;padding-bottom:0px;padding-left:40px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="margin: 10px 0; color:#151e23; font-size:16px; font-family:Georgia,Helvetica,Arial,sans-serif"><b>Cake Title</b></p>
                              <p style="line-height: 16px; margin: 10px 0;font-size:14px; color:#151e23; font-family:Georgia,Helvetica,Arial,sans-serif; color:#354552">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                              <p style="line-height: 16px; margin: 10px 0; color:#354552; font-size:14px; font-family:Georgia,Helvetica,Arial,sans-serif"><u>Choose me</u> &gt;</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-top:20px;padding-right:30px;padding-bottom:20px;padding-left:30px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:240px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/0gzvh.jpeg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="240" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

                  <td
                     class="" style="vertical-align:top;width:300px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:40px;padding-bottom:0px;padding-left:40px;word-break:break-word;">
                            <div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:left;color:#55575d;">
                              <p style="margin: 10px 0; color:#151e23; font-size:16px; font-family:Georgia,Helvetica,Arial,sans-serif"><b>Cake Title</b></p>
                              <p style="line-height: 16px; margin: 10px 0;font-size:14px; color:#151e23; font-family:Georgia,Helvetica,Arial,sans-serif; color:#354552">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                              <p style="line-height: 16px; margin: 10px 0; color:#354552; font-size:14px; font-family:Georgia,Helvetica,Arial,sans-serif"><u>Choose me</u> &gt;</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-top:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                              <tr>
                                <td align="center" bgcolor="#354552" role="presentation" style="border:none;border-radius:3px;cursor:auto;mso-padding-alt:10px 25px;background:#354552;" valign="middle">
                                  <p style="display:inline-block;background:#354552;color:#ffffff;font-family:Georgia, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:3px;"> Discover all desserts </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:600px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/068y3.jpeg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>

            <table
               align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600"
            >
              <tr>
                <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
            <![endif]-->
          <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
              <tbody>
                <tr>
                  <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                    <!--[if mso | IE]>
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">

              <tr>

                  <td
                     class="" style="vertical-align:top;width:600px;"
                  >
                <![endif]-->
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                              <tbody>
                                <tr>
                                  <td style="width:202px;">
                                    <img height="auto" src="http://5vph.mj.am/img/5vph/b/1g8pi/0gzjm.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="202" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                            <!--[if mso | IE]>
            <table
               align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
            >
              <tr>

                    <td>
                  <![endif]-->
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                              <tr>
                                <td style="padding:4px;vertical-align:middle;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3b5998;border-radius:3px;width:20px;">
                                    <tr>
                                      <td style="font-size:0;height:20px;vertical-align:middle;width:20px;">
                                        <img height="20" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/facebook.png" style="border-radius:3px;display:block;" width="20" />
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <!--[if mso | IE]>
                    </td>

                    <td>
                  <![endif]-->
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                              <tr>
                                <td style="padding:4px;vertical-align:middle;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#bd081c;border-radius:3px;width:20px;">
                                    <tr>
                                      <td style="font-size:0;height:20px;vertical-align:middle;width:20px;">
                                        <img height="20" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/pinterest.png" style="border-radius:3px;display:block;" width="20" />
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <!--[if mso | IE]>
                    </td>

                    <td>
                  <![endif]-->
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                              <tr>
                                <td style="padding:4px;vertical-align:middle;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3f729b;border-radius:3px;width:20px;">
                                    <tr>
                                      <td style="font-size:0;height:20px;vertical-align:middle;width:20px;">
                                        <img height="20" src="https://www.mailjet.com/images/theme/v1/icons/ico-social/instagram.png" style="border-radius:3px;display:block;" width="20" />
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <!--[if mso | IE]>
                    </td>

                </tr>
              </table>
            <![endif]-->
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!--[if mso | IE]>
                  </td>

              </tr>

                        </table>
                      <![endif]-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]>
                </td>
              </tr>
            </table>
            <![endif]-->
        </div>
      </body>

      </html>`
    },
    {
      name: 'Amario',
      thumbnailUri: require('@/assets/imgs/template005.png'),
      htmlContent: `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title></title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
      body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
      table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
      img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
      p { display:block;margin:13px 0; }</style><!--[if mso]>
    <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    <![endif]--><!--[if lte mso 11]>
    <style type="text/css">
      .mj-outlook-group-fix { width:100% !important; }
    </style>
    <![endif]--><style type="text/css">@media only screen and (min-width:480px) {
    .mj-column-per-100 { width:100% !important; max-width: 100%; }
  }</style><style type="text/css">@media only screen and (max-width:480px) {
  table.mj-full-width-mobile { width: 100% !important; }
  td.mj-full-width-mobile { width: auto !important; }
}</style></head><body style="background-color:#F4F4F4;"><div style="background-color:#F4F4F4;"><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#C1272D;background-color:#C1272D;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#C1272D;background-color:#C1272D;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:128px;"><img height="auto" src="http://gkq4.mjt.lu/img/gkq4/b/18rxz/1h3k4.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="128"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:550px;"><img height="auto" src="http://gkq4.mjt.lu/img/gkq4/b/18rxz/1h3s5.gif" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="550"></td></tr></tbody></table></td></tr><tr><td align="center" style="background:#ffffff;font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:399px;"><img alt="Happy New Year!" height="auto" src="http://gkq4.mjt.lu/img/gkq4/b/18rxz/1hlvp.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="399"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0px 20px 0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px 25px 0px 25px;word-break:break-word;"><div style="font-family:Arial, sans-serif;font-size:14px;line-height:28px;text-align:center;color:#55575d;">New dreams, new hopes, new experiences and new joys, we wish you all the best for this New Year to come in 2018!</div></td></tr><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:142px;"><img alt="Best wishes from all the Clothes Team!" height="auto" src="http://gkq4.mjt.lu/img/gkq4/b/18rxz/1hlv8.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="142"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#C1272D;background-color:#C1272D;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#C1272D;background-color:#C1272D;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Arial, sans-serif;font-size:13px;line-height:22px;text-align:center;color:#ffffff;">Simply created&nbsp;on&nbsp;<a style="color:#ffffff" href="http://www.mailjet.com"><b>Mailjet Passport</b></a></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0px 20px 0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px 20px;word-break:break-word;"><div style="font-family:Arial, sans-serif;font-size:11px;line-height:22px;text-align:center;color:#55575d;">[[DELIVERY_INFO]]</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div></body></html>`
    }
  ]
}

export function LayoutEmails() {
  return [
    {
      name: '1 Columnn',
      thumbnailUri: require('@/assets/imgs/1-column.png'),
      graopesHTML: `<mjml>
      <mj-head>
        <mj-title>UGG Royale</mj-title>
        <mj-attributes>
          <mj-image alt="" padding="0px"></mj-image>
          <mj-section padding="0px"></mj-section>
          <mj-class name="open-sans-button" font-family="Open Sans, Arial, sans-serif" background-color="#111111" color="#ffffff" height="30px" text-transform="uppercase" font-size="16px" text-decoration="none"></mj-class>
          <mj-class name="footer-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="10px" line-height="14px"></mj-class>
          <mj-class name="body-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="16px" line-height="26px" align="center"></mj-class>
          <mj-class name="headline-text" font-family="Big Caslon, Garamond, Times, serif" color="#111111" font-size="40px" line-height="36px" align="center" text-transform="uppercase"></mj-class>
        </mj-attributes>
        <mj-font name="Open Sans" href="http://fonts.googleapis.com/css?family=Open+Sans"></mj-font>
        <mj-style inline="inline">.link-nostyle { color: inherit; text-decoration: none }; /* Apple specific Links */ .apple-link-black a { color:#111111 !important; text-decoration:none; } .apple-link-gray a { color:#999999 !important; text-decoration:none; } .apple-link-white a
          { color:#ffffff !important; text-decoration:none; } .apple-link-tan a { color: #aa6034 !important; text-decoration: none; } .apple-link-light-grey a { color: #c7c8ca; text-decoration: none; } .preheader {display:none !important; visibility:hidden;
          mso-hide:all; max-height:0px; max-width:0px; opacity:0; overflow:hidden; width:100%;} img[class="img-max"] { max-width: 100% !important; width: 100% !important; height: auto !important; }
        </mj-style>
        <mj-style>@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }
        </mj-style>
      </mj-head>
      <mj-body background-color="#ffffff">
        <mj-section padding="0px">
          <mj-column>
            <mj-text font-size="1px" align="left" color="#ffffff" line-height="1px" font-family="'Open Sans', 'Raleway', Arial, Verdana, sans-serif" padding="0px"><span class="preheader"> No longer on backorder, the Royale is now here and waiting for you.
              </span></mj-text>
          </mj-column>
        </mj-section>

        <mj-wrapper padding="30px">
          <mj-section >
            <mj-column width="470px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/450x200" width="450px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>
          <mj-section >
          <mj-column>
            <mj-text mj-class="body-text" font-size="14px" line-height="26px" letter-spacing="2px" text-transform="uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</mj-text>
          </mj-column>
        </mj-section>
        <mj-wrapper background-color="#f9f9f9" padding="0px">
          <mj-section>
            <mj-column>
              <mj-image alt="Model in UGG in a baby blue royale" href="http://www.ugg.com/" width="600px" src="https://via.placeholder.com/600x400"></mj-image>
            </mj-column>
          </mj-section>
          <mj-section padding="30px 0 20px">
            <mj-column>
              <mj-text mj-class="headline-text">the<br /> Lorem Ipsum is simply dummy text.
              </mj-text>
            </mj-column>
          </mj-section>
        </mj-wrapper>

        <mj-section padding="0px">
          <mj-column>
            <mj-text mj-class="footer-text" align="center" padding="50px 10px">
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site:
                <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.xpto.com</a>
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on
                <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">
                <span style="color:#111111 !important; text-decoration:none;">
                  <strong>1.888.432.8530</strong>
                  <br /> 123 North Leroux Street, Flagstaff, AZ 86001
                </span>
                <br />
                <a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;">
                  <strong>Privacy Policy</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;">
                  <strong>Unsubscribe</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a>
              </p>
            </mj-text>
          </mj-column>
        </mj-section>
      </mj-body>
    </mjml>`,
      htmlContent: `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>UGG Royale</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
      body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
      table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
      img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
      p { display:block;margin:13px 0; }</style><!--[if mso]>
    <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    <![endif]--><!--[if lte mso 11]>
    <style type="text/css">
      .mj-outlook-group-fix { width:100% !important; }
    </style>
    <![endif]--><!--[if !mso]><!--><link href="http://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css"><style type="text/css">@import url(http://fonts.googleapis.com/css?family=Open+Sans);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px) {
    .mj-column-per-100 { width:100% !important; max-width: 100%; }
.mj-column-px-470 { width:470px !important; max-width: 470px; }
  }</style><style type="text/css">@media only screen and (max-width:480px) {
  table.mj-full-width-mobile { width: 100% !important; }
  td.mj-full-width-mobile { width: auto !important; }
}</style><style type="text/css">@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }</style></head><body style="background-color:#ffffff;"><div style="background-color:#ffffff;"><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:0px;word-break:break-word;"><div style="font-family:'Open Sans', 'Raleway', Arial, Verdana, sans-serif;font-size:1px;line-height:1px;text-align:left;color:#ffffff;"><span class="preheader" style="visibility: hidden; mso-hide: all; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; width: 100%; display: none;">No longer on backorder, the Royale is now here and waiting for you.</span></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:540px;" width="540" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:540px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:470px;" ><![endif]--><div class="mj-column-px-470 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:450px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/450x200" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="450"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:14px;letter-spacing:2px;line-height:26px;text-align:center;text-transform:uppercase;color:#111111;">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#f9f9f9;background-color:#f9f9f9;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#f9f9f9;background-color:#f9f9f9;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:600px;"><a href="http://www.ugg.com/" target="_blank"><img alt="Model in UGG in a baby blue royale" height="auto" src="https://via.placeholder.com/600x400" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px 0 20px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Big Caslon, Garamond, Times, serif;font-size:40px;line-height:36px;text-align:center;text-transform:uppercase;color:#111111;">the<br>Lorem Ipsum is simply dummy text.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:50px 10px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:10px;line-height:14px;text-align:center;color:#111111;"><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site: <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.xpto.com</a></p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.</p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;"><span style="color:#111111 !important; text-decoration:none;"><strong>1.888.432.8530</strong><br>123 North Leroux Street, Flagstaff, AZ 86001</span><br><a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;"><strong>Privacy Policy</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;"><strong>Unsubscribe</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a></p></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div></body></html>`
    },
    {
      name: '1:2 Columnn',
      thumbnailUri: require('@/assets/imgs/1-2-1-column.png'),
      graopesHTML: `<mjml>
      <mj-head>
        <mj-title>UGG Royale</mj-title>
        <mj-attributes>
          <mj-image alt="" padding="0px"></mj-image>
          <mj-section padding="0px"></mj-section>
          <mj-class name="open-sans-button" font-family="Open Sans, Arial, sans-serif" background-color="#111111" color="#ffffff" height="30px" text-transform="uppercase" font-size="16px" text-decoration="none"></mj-class>
          <mj-class name="footer-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="10px" line-height="14px"></mj-class>
          <mj-class name="body-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="16px" line-height="26px" align="center"></mj-class>
          <mj-class name="headline-text" font-family="Big Caslon, Garamond, Times, serif" color="#111111" font-size="40px" line-height="36px" align="center" text-transform="uppercase"></mj-class>
        </mj-attributes>
        <mj-font name="Open Sans" href="http://fonts.googleapis.com/css?family=Open+Sans"></mj-font>
        <mj-style inline="inline">.link-nostyle { color: inherit; text-decoration: none }; /* Apple specific Links */ .apple-link-black a { color:#111111 !important; text-decoration:none; } .apple-link-gray a { color:#999999 !important; text-decoration:none; } .apple-link-white a
          { color:#ffffff !important; text-decoration:none; } .apple-link-tan a { color: #aa6034 !important; text-decoration: none; } .apple-link-light-grey a { color: #c7c8ca; text-decoration: none; } .preheader {display:none !important; visibility:hidden;
          mso-hide:all; max-height:0px; max-width:0px; opacity:0; overflow:hidden; width:100%;} img[class="img-max"] { max-width: 100% !important; width: 100% !important; height: auto !important; }
        </mj-style>
        <mj-style>@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }
        </mj-style>
      </mj-head>
      <mj-body background-color="#ffffff">
        <mj-section padding="0px">
          <mj-column>
            <mj-text font-size="1px" align="left" color="#ffffff" line-height="1px" font-family="'Open Sans', 'Raleway', Arial, Verdana, sans-serif" padding="0px"><span class="preheader"> No longer on backorder, the Royale is now here and waiting for you.
              </span></mj-text>
          </mj-column>
        </mj-section>

        <mj-wrapper padding="30px">
          <mj-section >
            <mj-column width="470px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/450x200" width="450px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>
          <mj-section >
          <mj-column>
            <mj-text mj-class="body-text" font-size="14px" line-height="26px" letter-spacing="2px" text-transform="uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</mj-text>
          </mj-column>
        </mj-section>

        <mj-wrapper padding="0px">
          <mj-section >
            <mj-column width="270px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/250x300" width="250px"></mj-image>
            </mj-column>
            <mj-column width="270px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/250x300" width="250px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>

        <mj-section padding="30px">
          <mj-column>
            <mj-text mj-class="body-text" font-size="14px" line-height="26px" letter-spacing="2px" text-transform="uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</mj-text>
          </mj-column>
        </mj-section>


        <mj-section padding="0px">
          <mj-column>
            <mj-text mj-class="footer-text" align="center" padding="50px 10px">
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site:
                <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.ugg.com</a>
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on
                <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">
                <span style="color:#111111 !important; text-decoration:none;">
                  <strong>1.888.432.8530</strong>
                  <br /> 123 North Leroux Street, Flagstaff, AZ 86001
                </span>
                <br />
                <a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;">
                  <strong>Privacy Policy</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;">
                  <strong>Unsubscribe</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a>
              </p>
            </mj-text>
          </mj-column>
        </mj-section>
      </mj-body>
    </mjml>`,
      htmlContent: `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>UGG Royale</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
      body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
      table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
      img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
      p { display:block;margin:13px 0; }</style><!--[if mso]>
    <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    <![endif]--><!--[if lte mso 11]>
    <style type="text/css">
      .mj-outlook-group-fix { width:100% !important; }
    </style>
    <![endif]--><!--[if !mso]><!--><link href="http://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css"><style type="text/css">@import url(http://fonts.googleapis.com/css?family=Open+Sans);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px) {
    .mj-column-per-100 { width:100% !important; max-width: 100%; }
.mj-column-px-470 { width:470px !important; max-width: 470px; }
.mj-column-px-270 { width:270px !important; max-width: 270px; }
  }</style><style type="text/css">@media only screen and (max-width:480px) {
  table.mj-full-width-mobile { width: 100% !important; }
  td.mj-full-width-mobile { width: auto !important; }
}</style><style type="text/css">@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }</style></head><body style="background-color:#ffffff;"><div style="background-color:#ffffff;"><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:0px;word-break:break-word;"><div style="font-family:'Open Sans', 'Raleway', Arial, Verdana, sans-serif;font-size:1px;line-height:1px;text-align:left;color:#ffffff;"><span class="preheader" style="visibility: hidden; mso-hide: all; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; width: 100%; display: none;">No longer on backorder, the Royale is now here and waiting for you.</span></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:540px;" width="540" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:540px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:470px;" ><![endif]--><div class="mj-column-px-470 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:450px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/450x200" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="450"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:14px;letter-spacing:2px;line-height:26px;text-align:center;text-transform:uppercase;color:#111111;">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:270px;" ><![endif]--><div class="mj-column-px-270 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:250px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/250x300" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="250"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td><td class="" style="vertical-align:top;width:270px;" ><![endif]--><div class="mj-column-px-270 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:250px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/250x300" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="250"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:540px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:14px;letter-spacing:2px;line-height:26px;text-align:center;text-transform:uppercase;color:#111111;">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:50px 10px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:10px;line-height:14px;text-align:center;color:#111111;"><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site: <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.ugg.com</a></p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.</p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;"><span style="color:#111111 !important; text-decoration:none;"><strong>1.888.432.8530</strong><br>123 North Leroux Street, Flagstaff, AZ 86001</span><br><a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;"><strong>Privacy Policy</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;"><strong>Unsubscribe</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a></p></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div></body></html>`
    },
    {
      name: '1:2:1 Columnn',
      thumbnailUri: require('@/assets/imgs/1-2-1-column.png'),
      graopesHTML: `<mjml>
      <mj-head>
        <mj-title>UGG Royale</mj-title>
        <mj-attributes>
          <mj-image alt="" padding="0px"></mj-image>
          <mj-section padding="0px"></mj-section>
          <mj-class name="open-sans-button" font-family="Open Sans, Arial, sans-serif" background-color="#111111" color="#ffffff" height="30px" text-transform="uppercase" font-size="16px" text-decoration="none"></mj-class>
          <mj-class name="footer-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="10px" line-height="14px"></mj-class>
          <mj-class name="body-text" font-family="Open Sans, Arial, sans-serif" color="#111111" font-size="16px" line-height="26px" align="center"></mj-class>
          <mj-class name="headline-text" font-family="Big Caslon, Garamond, Times, serif" color="#111111" font-size="40px" line-height="36px" align="center" text-transform="uppercase"></mj-class>
        </mj-attributes>
        <mj-font name="Open Sans" href="http://fonts.googleapis.com/css?family=Open+Sans"></mj-font>
        <mj-style inline="inline">.link-nostyle { color: inherit; text-decoration: none }; /* Apple specific Links */ .apple-link-black a { color:#111111 !important; text-decoration:none; } .apple-link-gray a { color:#999999 !important; text-decoration:none; } .apple-link-white a
          { color:#ffffff !important; text-decoration:none; } .apple-link-tan a { color: #aa6034 !important; text-decoration: none; } .apple-link-light-grey a { color: #c7c8ca; text-decoration: none; } .preheader {display:none !important; visibility:hidden;
          mso-hide:all; max-height:0px; max-width:0px; opacity:0; overflow:hidden; width:100%;} img[class="img-max"] { max-width: 100% !important; width: 100% !important; height: auto !important; }
        </mj-style>
        <mj-style>@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }
        </mj-style>
      </mj-head>
      <mj-body background-color="#ffffff">
        <mj-section padding="0px">
          <mj-column>
            <mj-text font-size="1px" align="left" color="#ffffff" line-height="1px" font-family="'Open Sans', 'Raleway', Arial, Verdana, sans-serif" padding="0px"><span class="preheader"> No longer on backorder, the Royale is now here and waiting for you.
              </span></mj-text>
          </mj-column>
        </mj-section>

        <mj-wrapper padding="30px">
          <mj-section >
            <mj-column width="470px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/450x200" width="450px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>
          <mj-section >
          <mj-column>
            <mj-text mj-class="body-text" font-size="14px" line-height="26px" letter-spacing="2px" text-transform="uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</mj-text>
          </mj-column>
        </mj-section>

        <mj-wrapper padding="0px">
          <mj-section >
            <mj-column width="270px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/250x300" width="250px"></mj-image>
            </mj-column>
            <mj-column width="270px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/250x300" width="250px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>

        <mj-section padding="30px">
          <mj-column>
            <mj-text mj-class="body-text" font-size="14px" line-height="26px" letter-spacing="2px" text-transform="uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</mj-text>
          </mj-column>
        </mj-section>

            <mj-wrapper padding="30px">
          <mj-section >
            <mj-column width="470px">
              <mj-image href="http://www.ugg.com/" src="https://via.placeholder.com/450x200" width="450px"></mj-image>
            </mj-column>
          </mj-section>
        </mj-wrapper>


        <mj-section padding="0px">
          <mj-column>
            <mj-text mj-class="footer-text" align="center" padding="50px 10px">
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site:
                <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.ugg.com</a>
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on
                <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.
              </p>
              <p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">
                <span style="color:#111111 !important; text-decoration:none;">
                  <strong>1.888.432.8530</strong>
                  <br /> 123 North Leroux Street, Flagstaff, AZ 86001
                </span>
                <br />
                <a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;">
                  <strong>Privacy Policy</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;">
                  <strong>Unsubscribe</strong>
                </a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a>
              </p>
            </mj-text>
          </mj-column>
        </mj-section>
      </mj-body>
    </mjml>`,
      htmlContent: `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>UGG Royale</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
      body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
      table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
      img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
      p { display:block;margin:13px 0; }</style><!--[if mso]>
    <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    <![endif]--><!--[if lte mso 11]>
    <style type="text/css">
      .mj-outlook-group-fix { width:100% !important; }
    </style>
    <![endif]--><!--[if !mso]><!--><link href="http://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css"><style type="text/css">@import url(http://fonts.googleapis.com/css?family=Open+Sans);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px) {
    .mj-column-per-100 { width:100% !important; max-width: 100%; }
.mj-column-px-470 { width:470px !important; max-width: 470px; }
.mj-column-px-270 { width:270px !important; max-width: 270px; }
  }</style><style type="text/css">@media only screen and (max-width:480px) {
  table.mj-full-width-mobile { width: 100% !important; }
  td.mj-full-width-mobile { width: auto !important; }
}</style><style type="text/css">@media all and (max-width: 600px) { img[title*="img30"] { width:30% !important; } }</style></head><body style="background-color:#ffffff;"><div style="background-color:#ffffff;"><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:0px;word-break:break-word;"><div style="font-family:'Open Sans', 'Raleway', Arial, Verdana, sans-serif;font-size:1px;line-height:1px;text-align:left;color:#ffffff;"><span class="preheader" style="visibility: hidden; mso-hide: all; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; width: 100%; display: none;">No longer on backorder, the Royale is now here and waiting for you.</span></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:540px;" width="540" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:540px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:470px;" ><![endif]--><div class="mj-column-px-470 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:450px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/450x200" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="450"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:14px;letter-spacing:2px;line-height:26px;text-align:center;text-transform:uppercase;color:#111111;">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:270px;" ><![endif]--><div class="mj-column-px-270 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:250px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/250x300" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="250"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td><td class="" style="vertical-align:top;width:270px;" ><![endif]--><div class="mj-column-px-270 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:250px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/250x300" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="250"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:540px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:14px;letter-spacing:2px;line-height:26px;text-align:center;text-transform:uppercase;color:#111111;">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:30px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:540px;" width="540" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:540px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:470px;" ><![endif]--><div class="mj-column-px-470 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:0px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:450px;"><a href="http://www.ugg.com/" target="_blank"><img alt height="auto" src="https://via.placeholder.com/450x200" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="450"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:50px 10px;word-break:break-word;"><div style="font-family:Open Sans, Arial, sans-serif;font-size:10px;line-height:14px;text-align:center;color:#111111;"><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">We only send emails to individuals who have registered at our site: <a href="http://www.ugg.com/" name="footer_ugghomepage" style="color:#111111; text-decoration:underline;">www.ugg.com</a></p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;">*A free return label will be included with your order. This offer only applies to full price orders shipped within the continental United States and placed on <span class="apple-link-black">ugg.com</span>. Please note this offer does not apply to clearance product.</p><p style="Margin:0; padding-bottom:10px; font-size:10px; line-height:15px; Margin-bottom:10px; color:#111111; font-family: 'Open Sans', 'Raleway', Arial, Helvetica, sans-serif;"><span style="color:#111111 !important; text-decoration:none;"><strong>1.888.432.8530</strong><br>123 North Leroux Street, Flagstaff, AZ 86001</span><br><a href="http://www.ugg.com/" name="footer_privacy" style="color:#111111; text-decoration:underline;"><strong>Privacy Policy</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www.ugg.com/" style="text-decoration:underline; color:#111111;"><strong>Unsubscribe</strong> </a>&nbsp;&nbsp;|&nbsp;&nbsp; <a href="https://email.ugg.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGjmR9kDzfwzbMzackp9f3F8d45ze2zfbW8hYB6AzgB7gaIYB3tN5qwvasVXMtX%3DYQpglLjHJlTQGNXlMNF3fFUYHWCzdBj2rGzgJpzem2KonGoezgzbfUyABevzgl4CepTMC&_ei_=EolaGGF4SNMvxFF7KucKuWP7XpARYKtbBY43fLBYxvXNpGx2Z89j4M" style="text-decoration:underline; color:#111111;">View in Browser</a></p></div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div></body></html>`
    }
  ]
}
